import Swiper, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/bundle";
Swiper.use([Navigation]);

const cards = document.querySelectorAll(".p-case__card");
const caseNav = document.querySelector(".p-case__nav");

cards.forEach((card, i) => {
  const num = ("00" + (i + 1)).slice(-2);

  card.setAttribute("data-number", num);
  card.setAttribute("id", `case-${num}`);

  // case number
  const caseNumberDom = card.querySelector(".p-case__card__number");
  caseNumberDom.textContent = `CASE ${num}`;

  // slide
  const slider = card.querySelector(".p-case__card__slider");

  const prevBtn = `<div class="p-case__card__slider__button p-case__card__slider__button--prev p-case__card__slider__button--prev--${num} swiper-button-prev">
<svg xmlns="http://www.w3.org/2000/svg" width="7.414" height="13.414" viewBox="0 0 7.414 13.414">
  <g transform="translate(0.707 0.707)">
    <path d="M0,6.707-.707,6,6-.707,6.707,0Z" />
    <path d="M6,6.707-.707,0,0-.707,6.707,6Z" transform="translate(0 6)" />
  </g>
</svg>
</div>`;

  const nextBtn = `<div class="p-case__card__slider__button p-case__card__slider__button--next p-case__card__slider__button--next--${num} swiper-button-next">
<svg xmlns="http://www.w3.org/2000/svg" width="7.414" height="13.414" viewBox="0 0 7.414 13.414">
  <g transform="translate(0.707 0.707)">
    <path d="M6,6.707-.707,0,0-.707,6.707,6Z" />
    <path d="M0,6.707-.707,6,6-.707,6.707,0Z" transform="translate(0 6)" />
  </g>
</svg>
</div>`;

  slider.innerHTML += prevBtn + nextBtn;

  const cardSwiper = new Swiper(".p-case__card__slider__container", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: "auto",
    navigation: {
      nextEl: `.p-case__card__slider__button--next--${num}`,
      prevEl: `.p-case__card__slider__button--prev--${num}`,
    },
  });

  // nav
  const caseTitle = card.querySelector(".p-case__card__title").textContent;

  caseNav.innerHTML += `
  <li class="p-case__nav__item">
    <a href="#case-${num}" class="p-case__nav__item__link">
      <p class="p-case__nav__item__number">CASE ${num}</p>
      <p class="p-case__nav__item__title">
        <span>${caseTitle}</span>
        <i><svg xmlns="http://www.w3.org/2000/svg" width="13.414" height="7.414" viewBox="0 0 13.414 7.414"><g transform="translate(1989.207 -823.793) rotate(90)"><path d="M6,6.707-.707,0,0-.707,6.707,6Z" transform="translate(824.5 1976.5)"/><path d="M0,6.707-.707,6,6-.707,6.707,0Z" transform="translate(824.5 1982.5)"/></g></svg></i>
      </p>
    </a>
  </li>
  `;
});
